import { useEffect, useRef } from "react";
import { Html5Qrcode } from "html5-qrcode";

const BarcodeScanner = ({ onScan }) => {
  const scannerRef = useRef(null);
  const onScanRef = useRef(onScan);

  useEffect(() => {
    onScanRef.current = onScan;
  }, [onScan]);

  useEffect(() => {
    const scanner = new Html5Qrcode("barcode-reader");
    scannerRef.current = scanner;
    let stopped = false;

    scanner
      .start(
        { facingMode: "environment" },
        {
          fps: 10,
          qrbox: { width: 300, height: 150 },
        },
        (decodedText) => {
          if (stopped) {
            return;
          }
          stopped = true;
          console.log("Barcode:", decodedText);
          onScanRef.current?.(decodedText);
          scanner.stop().catch(console.error);
        },
        () => {
          // Ignore scanning errors
        },
      )
      .catch((error) => {
        console.error("Camera error:", error);
      });

    return () => {
      stopped = true;
      if (scanner.isScanning) {
        scanner.stop().catch(console.error);
      }
    };
  }, []);

  return (
    <div>
      <div id="barcode-reader" />
    </div>
  );
};

export default BarcodeScanner;
